import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import PropTypes from 'prop-types';
import Box from '../Box';
import { useThemeDefaults } from '../utils';
import { panelColors } from '../theme';
var Panel = useThemeDefaults(function (_ref) {
  var _ref$panelColors = _ref.panelColors,
      panelColors = _ref$panelColors === void 0 ? 'standard' : _ref$panelColors,
      theme = _ref.theme;
  return _objectSpread({
    p: theme.panelPadding
  }, theme.panelColors[panelColors]);
}, Box);
Panel.propTypes = _objectSpread(_objectSpread({}, Box.propTypes), {}, {
  panelColors: PropTypes.oneOf(Object.keys(panelColors))
});
export default Panel;